/* Gustos de toda la web (se encienden/apagan en Configuración del tema → Gustos de la web; theme.liquid
   pone una clase en el <body> por cada uno). Nada corre solo: todo pasa al llegar una foto o al tocar. */
(function () {
  var body = document.body;

  /* ── Fotos que llegan borrosas y se enfocan ──
     Mientras la foto buena no ha llegado, debajo se ve ella misma en miniatura (24 px, ~0,5 KB) desenfocada,
     en vez de una caja gris. Al llegar, aparece encima con un fundido. Las que ya estaban en caché no se tocan. */
  if (body.classList.contains('fh-g-borrosa')) {
    var SEL = '.product-card__media img:not(.swap),.lbc-img img,.fh-pop-card__media img,.pdp-slide img,[data-fh-lq] img';
    var tiny = function (src) {
      if (!src || src.indexOf('data:') === 0 || /\.gif(\?|$)/i.test(src)) return '';
      if (src.indexOf('/cdn/shop/') < 0 && src.indexOf('cdn.shopify.com') < 0) return '';
      return /([?&])width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=24') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=24';
    };
    var prep = function (img) {
      if (img._fhLq) return; img._fhLq = 1;
      if (img.complete && img.naturalWidth) return; // ya está: nada que hacer
      var box = img.parentElement, t = tiny(img.getAttribute('src'));
      if (!box || !t) return;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      box.style.setProperty('--lq', 'url("' + t + '")');
      box.classList.add('fh-lq'); img.classList.add('fh-lq-img');
      var done = function () {
        img.classList.add('is-in');
        setTimeout(function () { box.classList.remove('fh-lq'); img.classList.remove('fh-lq-img', 'is-in'); }, 800);
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    };
    // Solo las que van a verse pronto (la miniatura también es una descarga, aunque diminuta)
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); prep(e.target); } });
    }, { rootMargin: '600px 0px' }) : null;
    var scan = function (root) {
      (root || document).querySelectorAll(SEL).forEach(function (img) {
        if (img._fhLqSeen) return; img._fhLqSeen = 1;
        if (img.complete && img.naturalWidth) return;
        io ? io.observe(img) : prep(img);
      });
    };
    scan();
    // tarjetas que llegan después (filtros, «cargar más», buscador)
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; scan(); });
    }).observe(document.getElementById('MainContent') || body, { childList: true, subtree: true });
  }

  /* ── Paso suave entre páginas: la foto de la tarjeta viaja a la ficha ──
     El @view-transition lo declara theme.liquid. Aquí solo se le pone nombre a la foto tocada justo antes de salir. */
  if (body.classList.contains('fh-g-vt')) {
    var lastCard = null, lastT = 0;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/products/"]'); if (!a) { lastCard = null; return; }
      var card = a.closest('.product-card, .lbc, .fh-pop-card, .cd-sug, [data-fh-vt-card]');
      var media = card && card.querySelector('.product-card__imglink, .lbc-img, .fh-pop-card__media, .cd-sug__img, [data-fh-vt-card-foto]');
      lastCard = media || null; lastT = Date.now();
    }, true);
    window.addEventListener('pageswap', function (e) {
      if (!e.viewTransition) return;
      if (!lastCard || Date.now() - lastT > 4000 || !lastCard.isConnected) return;
      // si estamos en una ficha, su foto suelta el nombre para que no haya dos iguales
      document.querySelectorAll('#MainImage, [data-fh-vt-foto]').forEach(function (m) { m.style.viewTransitionName = 'none'; });
      lastCard.style.viewTransitionName = 'fh-foto';
    });
    // al volver atrás (página guardada en memoria) los nombres vuelven a como estaban
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('[style*="view-transition-name"]').forEach(function (m) { m.style.viewTransitionName = ''; });
    });
  }
})();
